/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Add_Frame_To_StartInputs */

const en_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add 1 Frame To Start`)
};

const fr_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter 1 image au debut`)
};

const de_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge 1 Frame hinzu, um zu beginnen`)
};

const it_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi 1 fotogramma all'inizio`)
};

const ru_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить 1 кадр в начало`)
};

const es_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir 1 fotograma para empezar`)
};

const zh_cn2_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始时添加 1 帧`)
};

const ja_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始に1フレームを追加`)
};

const hi_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआत में 1 फ्रेम जोड़ें`)
};

const pt_pt2_shortcut_keys_name_add_frame_to_start = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione 1 quadro ao início`)
};

/**
* | output |
* | --- |
* | "Add 1 Frame To Start" |
*
* @param {Shortcut_Keys_Name_Add_Frame_To_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_add_frame_to_start = /** @type {((inputs?: Shortcut_Keys_Name_Add_Frame_To_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Add_Frame_To_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_add_frame_to_start(inputs)
	if (locale === "de") return de_shortcut_keys_name_add_frame_to_start(inputs)
	if (locale === "it") return it_shortcut_keys_name_add_frame_to_start(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_add_frame_to_start(inputs)
	if (locale === "es") return es_shortcut_keys_name_add_frame_to_start(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_add_frame_to_start(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_add_frame_to_start(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_add_frame_to_start(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_add_frame_to_start(inputs)
	return en_shortcut_keys_name_add_frame_to_start(inputs)
});